import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IAccordionItemProps } from '../components/accordion/accordion-item/accordion-item';

export class AccordionItemModel extends ContentItem {
  get header(): string {
    return get(this._config, 'elements.header_value.value', '');
  }

  get children(): IKontentItem[] {
    return get(this._config, 'elements.items.value', []);
  }

  public static create(data: IAccordionItem): IAccordionItemProps {
    const { header, children } = new AccordionItemModel(data);
    return {
      header,
      children
    };
  }
}
